var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cta"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v("Our funeral specialists are on hand, and ready to help.")]),_c('Phone',{attrs:{"collapsable":false,"blurb":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }